import Marquee from "react-fast-marquee";

// NOTE: These are illustrative sample values, not live market data. To display
// real quotes, wire this component up to a real quote provider (e.g. Alpha
// Vantage, Finnhub, Polygon) via a backend endpoint that respects the
// provider's licensing terms. Until then the "SAMPLE" label below keeps the
// ticker legally and editorially honest.
const tickers = [
  { symbol: "S&P 500", value: "5,891.24", change: "+0.42%", up: true },
  { symbol: "NASDAQ", value: "19,247.11", change: "+0.71%", up: true },
  { symbol: "DOW", value: "43,152.03", change: "-0.18%", up: false },
  { symbol: "BTC", value: "$104,281", change: "+2.14%", up: true },
  { symbol: "ETH", value: "$3,912", change: "+1.02%", up: true },
  { symbol: "GOLD", value: "$2,731/oz", change: "+0.32%", up: true },
  { symbol: "US10Y", value: "4.24%", change: "-3bp", up: false },
  { symbol: "WTI", value: "$71.85", change: "-1.02%", up: false },
  { symbol: "EUR/USD", value: "1.0492", change: "+0.11%", up: true },
  { symbol: "VIX", value: "16.42", change: "-2.3%", up: false },
];

export default function StockTicker() {
  return (
    <div
      data-testid="stock-ticker"
      className="border-b border-foreground/10 bg-foreground text-background py-2 text-xs font-mono overflow-hidden flex items-center"
    >
      <span
        data-testid="stock-ticker-sample-label"
        className="hidden sm:inline-block flex-shrink-0 px-3 border-r border-background/20 uppercase tracking-widest text-[10px] text-amber-300 font-bold"
        title="These values are illustrative sample data, not live market quotes."
      >
        Sample data
      </span>
      <div className="flex-1 min-w-0">
      <Marquee gradient={false} speed={45} pauseOnHover>
        {tickers.map((t) => (
          <span key={t.symbol} className="mx-6 inline-flex items-center gap-2">
            <span className="font-semibold tracking-wider">{t.symbol}</span>
            <span className="opacity-80">{t.value}</span>
            <span className={t.up ? "text-emerald-400" : "text-rose-400"}>
              {t.change}
            </span>
            <span className="opacity-30 ml-4">•</span>
          </span>
        ))}
      </Marquee>
      </div>
    </div>
  );
}
